import React from 'react';

import ContentGazetters from './Gazetters';
import ContentAnnotations from './Annotations';

class ChooseContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { typeAnnotations, selectedType, textLetter, annotations, gazetters, addNewGazetter, withChildren } = this.props;

        if (!typeAnnotations) {
            typeAnnotations = 'annotate';
        }
        
        if (typeAnnotations === 'annotate') {
            return <ContentGazetters
                withChildren={withChildren}
                gazetters={gazetters}
                addNewGazetter={addNewGazetter}
                textLetter={textLetter}
            />;
        } else {
            return <ContentAnnotations
                selectedTyp={selectedType}
                typeAnnotations={typeAnnotations}
                annotations={annotations}
                textLetter={textLetter}
            />;
        }
    }
}

export default ChooseContent;


// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Content/ChooseContent.jsx